import { MagazineCards } from "../../../react4xp/parts/magazine-cards/magazine-cards";

export default (props) => <MagazineCards {...props} />
